import { render, staticRenderFns } from "./EmployeeAddNew.vue?vue&type=template&id=2c7e7007&"
import script from "./EmployeeAddNew.vue?vue&type=script&lang=js&"
export * from "./EmployeeAddNew.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAddNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports